//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import general from '@/common/library'
import uniIcon from '@/components/uni-icon/uni-icon'
import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
import search from 'components/search/index.vue'
export default {
	data(){
		return {
			defaultSelect:'类型',
			selectList:[],
			columnsForSort: ['销量从高到低', '价格从高到低', '价格从低到高'],
			header:'',
			noImg:require('static/noimage.png'),
			headerJumpUrl:'',
			list:[],
			dataList:{
				dataList1:[],
				dataList2:[]
			},
			name:'',
			end:false,
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false
			},
			form:{
				type:0,
				specialtyName:'',
				specialtyCode:''
			},
			menu: [ // 筛选菜单栏
                {
                    title: '特产类型',
                    detailList: []
                },
                {
                    title: '特产排序',
                    detailList: [
                        { name: '销量从高到低', code: 1 },
                        { name: '价格从高到低', code: 2 },
                        { name: '价格从低到高', code: 3 },
                        { name: '评分从高到低', code: 5 }
                    ]
                }
            ]
		}
	},
	components:{
		uniIcon,
		uniLoadMore,
		search
		// areaSearch
	},
	onReady(){



	},
	onLoad() {
		this.getList()
		this.getLabelList()
	},
	onPullDownRefresh() {
		// this.list=[]
		this.dataList.dataList1=[]
		this.dataList.dataList2=[]
		this.page.currentPage=1
		this.getList('refresh')
	},
	onReachBottom() {
		if(this.dataList.dataList1.length+this.dataList.dataList2.length<this.count){
	    this.getList()
		}
	},
	filters: {
		subLength (val, length) {
		return general._subLength(val, length)
		}
	},
	methods:{
		 mountMenu(arg) {
			 var _this=this
			var temp = _this.list
			var index = arg || 0
			const query = uni.createSelectorQuery().in(this);//页面跳转时，实例初始化，导致无法找到该实例，高度会出现不存在的问题
															//将选择器的选取范围更改为自定义组件 component 内，返回一个 SelectorQuery 对象实例。
															//（初始时，选择器仅选取页面范围的节点，不会选取任何自定义组件中的节点）。
			query.selectAll('.specialty').boundingClientRect(function (rect) {
				if (temp.length > index) {
						let height1=rect[0].height
						let height2=rect[1].height
						if(height1<=height2){
							_this.dataList[`dataList1`].push(_this.list[index])
						} else {
							_this.dataList[`dataList2`].push(_this.list[index])
						}
						_this.$nextTick(() => {
							_this.mountMenu(index + 1)
						})
				}
				
			}).exec()
		},
		getList(status){
			let _this=this
			_this.page.loading=true
			this.$ajax({
				method: 'post',
				url: '/weChat/specialtyProduct/queryPage',
				data: {
				..._this.form,
				  currentPage:_this.page.currentPage,
				  pageSize: _this.page.pageSize
				}
			}).then(res=>{
				// _this.list.push.apply(_this.list,res.data)
				if(res.data){
					_this.list=res.data
					_this.list=_this.list.map(e=>{
						return {
							...e,
							specialtyCodeNames:e.specialtyCodeName.split(',')
						}
					})
					_this.count=res.count
					if(_this.list.length+_this.dataList.dataList1.length+_this.dataList.dataList2.length>=_this.count){
						_this.end=true
					}
					_this.page.currentPage+=1
					if(status==='refresh'){
						uni.stopPullDownRefresh();
					}
					_this.$nextTick(()=>{
						_this.mountMenu()
					})
				}
				_this.page.loading=false
			})
		},
		search(){
			// this.list=[]
			this.dataList.dataList1=[]
			this.dataList.dataList2=[]
			this.page.currentPage=1
			this.getList()
		},
		nameInput(e){
			this.form.specialtyName=e.target.value
		},
		confirm(item){
			if (item.index === 0) {
                this.form.specialtyCode=item.code || ''
            } else if (item.index === 1) {
                this.form.type = item.code || ''
			}
			this.search()
		},
		reset(index){
            if(index===0){
               this.form.specialtyCode = ''
            }else if(index === 1) {
                this.form.type = 0
            }
            this.search()
		},
		getLabelList () {
			this.$ajax({
				method: 'post',
				url: '/weChat/specialtyProduct/querySpecialtyTypeList',
				data: {
				}
			}).then(result => {
				this.menu[0].detailList=result.data.specialtyTypeInfos
			})
		},
	}
}
